import { useQuery } from '@tanstack/react-query';
import { CLIENT_ID_QUERY_KEY } from '@/consts/const';
import { useFetch } from '@/hooks/useFetch';
import { useSearchQuery } from '@/hooks/useSearchQuery';
import type { GetClientResponse } from '@/types/clientsApiTypes';
import { CLIENT_CREATE_QUERY_KEY } from '../../const/const';

export const useGetClientDetailsQuery = (clientId?: string | number | null) => {
  const [query] = useSearchQuery();
  const clientIdForPayload = clientId ?? query.get(CLIENT_ID_QUERY_KEY);
  const { doFetch: getClient } = useFetch<void, GetClientResponse>();

  return useQuery({
    queryKey: [CLIENT_CREATE_QUERY_KEY, clientIdForPayload],
    queryFn: () => getClient(`/api/client-details/${clientIdForPayload}`),
    enabled: !!clientIdForPayload,
  });
};